const selectedTestResults = state => {
  return state.selectedTestResults
}

const selectedTestResultsCount = state => {
  const laboratoryCount = state.selectedTestResults.laboratory.length
  const imagesCount = state.selectedTestResults.images.length
  return laboratoryCount + imagesCount
}

const resultsBeingAnalyzedCount = state => {
  const laboratoryCount = Object.keys(
    state.resultsBeingAnalyzed.laboratory
  ).length
  const imagesCount = Object.keys(state.resultsBeingAnalyzed.images).length
  return laboratoryCount + imagesCount
}

const resultsBeingAnalyzedIds = state => {
  const laboratory = Object.values(state.resultsBeingAnalyzed.laboratory)
  const images = Object.values(state.resultsBeingAnalyzed.images)
  return [...laboratory, ...images]
}
const displayTestResultAnalysisFeature = (_, __, rootState) => {
  return rootState.permissions.testResults.analysis.view
}

export default {
  selectedTestResults,
  selectedTestResultsCount,
  displayTestResultAnalysisFeature,
  resultsBeingAnalyzedCount,
  resultsBeingAnalyzedIds
}
